export default "__VITE_ASSET__CBzI_CWT__"